import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "../redirectURL"
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";
import Select from "react-select";
import "../../assets/css/inventorymanagement.css"

const ActiveSkus = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [lockStatus, setLockStatus] = useState(1)
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [file, setFile] = useState(null)
  const [isLoadTrue, setIsLoadTrue] = useState(false)
  const [isFormLocked, setIsFormLocked] = useState(false);
  const [columnWithDefs, setColumnWithDefs] = useState([])
  const [currentSku, setCurrentSku] = useState({ label: "ALL", value: "" })
  const [filterDestinationOptions, setFilterDestinationOptions] = useState([]);
  const [currentDestination, setCurrentDestination] = useState({ label: "ALL", value: "" });

  const [prevSku, setPrevSku] = useState(null)
  const [skuOptions, setSkuOptions] = useState([])
  const [destinationOptions, setDestinationOptions] = useState([]);
  const [availableSkus, setAvailableSkus] = useState([]);
  const [loadingSkus, setLoadingSkus] = useState(false)
  const destSelectRef = useRef(null);
  const skuSelectRef = useRef(null);

  const [editFormData, setEditFormData] = useState({
    sku_code: "",
    sku_name: "",
    sku_category: "",
    destination_store_name: "",
    destination_store_id: "",
    is_active: true,
    is_active_string: "Active",
    inserted_date: "",
    updated_date: "",
  });

  const [duplicatedEditData, setDuplicatedEditData] = useState({
    sku_code: "",
    sku_name: "",
    sku_category: "",
    destination_store_name: "",
    destination_store_id: "",
    is_active: true,                 // Default to true
    is_active_string: "Active",      // Default to "Active"
    inserted_date: "",
    updated_date: "",
  });

  // normalize 0/1/"Active"/"Inactive"/boolean to boolean
  const normalizeIsActive = (val) => {
    if (typeof val === "boolean") return val;
    if (val === 1 || val === "1" || String(val).toLowerCase() === "active") return true;
    if (val === 0 || val === "0" || String(val).toLowerCase().includes("inactive")) return false;
    return Boolean(val);
  };

  const withStatusStrings = (isActiveBool) => ({
    is_active: isActiveBool,
    is_active_string: isActiveBool ? "Active" : "Inactive",
  });


  const gridApi = useRef(null);
  const gridColumnApi = useRef(null);

  const autoSizeAllColumns = () => {
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns?.length) {
        const allColumnIds = allColumns.map((col) => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  };

  const fetchAvailableSkus = async (destinationStoreId) => {
    if (!destinationStoreId) {
      setAvailableSkus([]);
      return;
    }

    setLoadingSkus(true);
    try {
      const response = await redirectURL.post(
        "indentation/getAvailableSkusForDestination",
        { destination_store_id: destinationStoreId }
      );

      if (response.data.status === "success") {
        setAvailableSkus(response.data.data);
      } else {
        setAvailableSkus([]);
      }
    } catch (error) {
      console.error("Error fetching available SKUs:", error);
      setAvailableSkus([]);
    } finally {
      setLoadingSkus(false);
    }
  };
  const resetFormData = () => {
    setEditFormData({
      sku_code: "",
      sku_name: "",
      sku_category: "",
      destination_store_name: "",
      destination_store_id: "",
      is_active: true,
      is_active_string: "Active",
      inserted_date: "",
      updated_date: "",
    });
    setDuplicatedEditData({
      sku_code: "",
      sku_name: "",
      sku_category: "",
      destination_store_name: "",
      destination_store_id: "",
      is_active: true,
      is_active_string: "Active",
      inserted_date: "",
      updated_date: "",
    });
    setAvailableSkus([]);
    setUploadedFileData([]);
    setFile(null);
    // clear react-select UI
    destSelectRef.current?.clearValue?.();
    skuSelectRef.current?.clearValue?.();
  };
  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData();
    setUploadedFileData([]);
    setAvailableSkus([]); // Clear available SKUs when closing
  };

  const onClickAddNewProduct = () => {
    resetFormData();
    setSliderOpen(true);
    setSliderType(1)
    setSliderCl("slider-25");
    setSliderTitle("Add New Sku Mapping");
    setOverlyBlock("show-m");
  };

  const handleEdit = (row) => {
    const isActive = normalizeIsActive(row.is_active ?? row.is_active_string);
    const status = withStatusStrings(isActive);

    setSliderOpen(true);
    setSliderType(3);
    setSliderCl("slider-25");
    setSliderTitle(`Edit SKU - ${row.sku_code || row.destination_store_id || ""}`);
    setOverlyBlock("show-m");
    setLockStatus(isActive ? 1 : 0);

    const next = {
      sku_code: row.sku_code || "",
      sku_name: row.sku_name || "",
      sku_category: row.sku_category || "",
      destination_store_name: row.destination_store_name || "",
      destination_store_id: row.destination_store_id || "",
      ...status,
      inserted_date: row.inserted_date || row.insertedDate || "",
      updated_date: row.updated_date || row.updatedDate || "",
    };

    setEditFormData(next);
    setDuplicatedEditData(next);
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDeletePopup(true);
    setOverlayBlock("show-m");

  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  }
  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }


const generateColumnDefs = (data) => {
  if (!Array.isArray(data) || !data.length) return [];

  const samples = data.slice(0, Math.min(data.length, 5));

  const skipKeys = new Set([
    "_id",
    "sheet_id",
    "sr",
    "created_date",
    "sheet_name",
    "category_x",
    "is_active",
    "updated_date",
  ]);

  const uniqueKeys = [
    ...new Set(samples.flatMap((record) => Object.keys(record))),
  ].filter((key) => !skipKeys.has(key));

  const columns = uniqueKeys.map((key) => {
    const lowerKey = key.toLowerCase();

    // find first non-null sample value
    const sampleValue = samples.map((r) => r[key]).find((v) => v != null);
    let type = typeof sampleValue;

    if (
      lowerKey.includes("date") ||
      lowerKey === "b2b_oos" ||
      lowerKey === "b2c_oos"
    ) {
      type = "date";
    } else if (sampleValue === null) {
      type = "string";
    }

    // header name formatting
    let headerName = key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase())
      .replace(/\bis_active_string\b/gi, "Status")
      .replace(/\bB2b\b/gi, "B2B")
      .replace(/\bB2c\b/gi, "B2C")
      .replace(/\bOos\b/gi, "OOS")
      .replace(/\bDs\b/gi, "DS")
      .replace(/\bDoh\b/gi, "DOH");

    const baseWidth = headerName.length * 8 + 40;

    const def = {
      headerName,
      field: key,
      sortable: true,
      filter: true,
      width: baseWidth,
      headerClass: "ag-header-wrap-text",
      autoHeaderHeight: true,
    };

    if (type === "number") {
      def.type = "numericColumn";
      def.cellStyle = { textAlign: "right" };
    } else if (type === "date") {
      def.valueGetter = ({ data }) => {
        const raw = data?.[key];
        if (!raw) return "";
        const date = new Date(raw);
        if (isNaN(date.getTime())) return raw;
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
          2,
          "0"
        )}-${String(date.getDate()).padStart(2, "0")}`;
      };
      def.cellClass = "dateType";
    }

    return def;
  });

  const editColumn = {
    headerName: "",
    field: "actions",
    sortable: false,
    filter: false,
    width: 90,
    cellClass: "custom-cell",
    cellRendererFramework: (params) => {
      const { is_active } = params.data || {};
      return (
        <div
          style={{
            height: "36px",
            padding: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            title="Edit"
            className="mt-2"
            style={{
              height: "30px",
              width: "60px",
              padding: "0 10px",
              border: "1px solid #93385D",
              borderRadius: "4px",
              backgroundColor: is_active === 0 ? "#da86a7ff" : "#F4EBEF",
              fontSize: "0.8rem",
              color: is_active === 0 ? "white" : "#93385D",
            }}
            onClick={() => handleEdit(params.data)}
          >
            Edit
          </button>
        </div>
      );
    },
  };

  return [editColumn, ...columns];
};



  const getSkuMasterData = async (sku, destination) => {
    var params = {}
    if (sku) {
      params.sku_code = sku
    }
    if (destination) {
      params.destination_store_id = destination
    }
    console.log(params, 'params');

    try {
      const response = await redirectURL.post("indentation/getActiveSkusData", params)
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const data = response.data.data

          const skuOptions = response.data.sku_options

          const master_skus_options = response.data.master_skus

          const uniqueDestinations = [...new Map(data.map(item =>
            [item.destination_store_id, {
              destination_store_id: item.destination_store_id,
              destination_store_name: item.destination_store_name
            }]
          )).values()];

          const destOptions = uniqueDestinations.map(dest => ({
            value: dest.destination_store_id,
            label: `${dest.destination_store_id} - ${dest.destination_store_name}`,
            fullData: dest
          }));

          // setDestinationOptions(destOptions);
          const colDefs = generateColumnDefs(data);
          const updatedData = data.filter(item => item.is_delete !== 1)

          setSkuOptions(skuOptions)
          setColumnWithDefs(colDefs)
          setRowData(updatedData);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setTimeout(() => autoSizeAllColumns(), 100);

        } else {
          setBasicTitle("No Active SKUs data found");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      console.error("Error fetching Active SKUs data:", error);
      setBasicTitle("Failed to fetch Active SKUs data");
      setBasicType("error");
      setShow(true);
    }
  }


  const getDistictDestination = async () => {
    try {
      const response = await redirectURL.post("indentation/getDistictDestination");
      if (response.status === 200 && response.data.data?.length > 0) {
        const allOption = {
          label: "ALL",
          value: ""
        };
        const formatted = [
          allOption,
          ...response.data.data.map(opt => ({
            ...opt,
            label: opt.value ? `${opt.value} - ${opt.label}` : opt.label
          }))
        ];
        const formatted_new = response.data.data.map(opt => ({
          ...opt,
          label: opt.value ? `${opt.value} - ${opt.label}` : opt.label
        }));
        setFilterDestinationOptions(formatted);
        setDestinationOptions(formatted_new);
      }
    } catch (error) {
      console.error("Failed to fetch Destination data:", error.message);
    }
  };

  useEffect(() => {
    const getData = async () => {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      // await getSkuOptions()
      await getDistictDestination()
      await getSkuMasterData()
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
    getData()

  }, []);

  const closeAlert = () => {
    const fileInput = document.getElementById("bulkUploadFile");
    if (fileInput !== null) {  // Check if the element exists
      fileInput.value = "";  // Clears the input if element exists
    }
    setUploadedFileData([]);
    setFile(null)
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setShowDeletePopup(false)
    setSliderOpen(false)
    resetFormData();
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData();
    setUploadedFileData([]);
  };

  const downloadExcelTemplate = () => {
    const sampleData = [
      [
        "Destination Store Id",
        "Destination Store Name",
        "Destination Store Address",
        "Region",
      ]
    ];

    const ws = utils.aoa_to_sheet(sampleData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    writeFile(wb, "sample_destination_template.xlsx");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value)
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });
      const mapping = {
        "Destination Store Id": "destination_store_id",
        "Destination Store Name": "destination_store_name",
        "destination Store address": "destination_store_address",
        "Region": "region"
      };

      function toSnakeCase(str) {
        return str
          .trim()
          .replace(/\s+/g, '_')           // replace spaces with underscores
          .replace(/[A-Z]/g, letter => letter.toLowerCase()) // lowercase any capitals
          .replace(/[^a-z0-9_]/g, '')     // remove any special chars if needed
      }

      const result = parsedData.map(item => {
        const newItem = {};
        for (const key in item) {
          if (mapping[key]) {
            newItem[mapping[key]] = item[key];
          } else {
            newItem[toSnakeCase(key)] = item[key];
          }
        }
        return newItem;
      });

      console.log("Parsed Data:", result);
      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };

  const onClickingFileSubmit = async () => {
    if (uploadedFileData.length === 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file");
      return;
    }
    const params = { masterData: uploadedFileData };
    try {
      const response = await redirectURL.post(
        "masters/storeDestinationMasterData",
        params
      );
      if (response.data.status === "success") {
        setUploadedFileData([])
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Data Uploaded Successfully");
        setIsLoadTrue(true)

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Bulk Uploaded Destination",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Data Upload Failed");
        setIsLoadTrue(true)

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Bulk Uploaded Destination",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "An error occurred";
      setUploadedFileData([])
      setShow(true);
      setBasicType("info");
      setBasicTitle(errorMessage);
      setIsLoadTrue(true)
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Bulk Uploaded Destination",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  };

  // Add these functions to your React component

  const downloadActiveSkusExcelTemplate = () => {
    const sampleData = [
      // Header row
      ["SKU Code", "Destination Store Id"],
      // Sample data rows
      ["MCQ", "D010"],
      ["HPDBC", "D001"],
      ["DBCP", "D002"]
    ];

    const ws = utils.aoa_to_sheet(sampleData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "ActiveSKUsTemplate");

    // Add validation notes sheet
    const notesData = [
      ["Sample Valid Data:"],
      ["SKU Code", "Destination Store Id"],
      ["MCQ", "D010"],
      ["HPDBC", "D001"]
    ];

    const notesWs = utils.aoa_to_sheet(notesData);
    utils.book_append_sheet(wb, notesWs, "Instructions");

    writeFile(wb, "active_skus_bulk_upload_template.xlsx");
  };


  const handleActiveSkusFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value);

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });

      const mapping = {
        "SKU Code": "sku_code",
        "Destination Store Id": "destination_store_id",
        "Destination Store ID": "destination_store_id",
        "SKU": "sku_code"
      };

      const result = parsedData.map((item, index) => {
        const newItem = {};
        for (const key in item) {
          if (mapping[key]) {
            newItem[mapping[key]] = item[key];
          } else {
            // Auto-detect columns based on common patterns
            const lowerKey = key.toLowerCase();
            if (lowerKey.includes('sku') && lowerKey.includes('code')) {
              newItem.sku_code = item[key];
            } else if (lowerKey.includes('destination') && lowerKey.includes('store') && lowerKey.includes('id')) {
              newItem.destination_store_id = item[key];
            }
          }
        }
        return newItem;
      }).filter(item => item.sku_code && item.destination_store_id); // Only include records with both fields

      console.log("Parsed Active SKUs Data:", result);
      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };

  const onClickingActiveSkusFileSubmit = async () => {
    if (uploadedFileData.length === 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file");
      return;
    }

    const params = { masterData: uploadedFileData };

    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      const response = await redirectURL.post(
        "indentation/storeActiveSkusData",
        params
      );

      if (response.data.status === "success") {
        setUploadedFileData([]);
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle(response.data.message || "Active SKUs Data Uploaded Successfully");

        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Bulk Uploaded Active SKUs",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);

      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");

        // Handle validation errors with detailed messages
        let errorMessage = response.data.message || "Data Upload Failed";

        // If there are multiple validation errors, show them in a formatted way
        if (response.data.errors && Array.isArray(response.data.errors)) {
          errorMessage = (
            <div>
              <strong style={{ color: '#d9534f' }}>{response.data.message || "Validation Errors"}:</strong>
              <ul style={{ margin: '10px 0', paddingLeft: '20px', maxHeight: '200px', overflowY: 'auto' }}>
                {response.data.errors.map((error, index) => (
                  <li key={index} style={{ fontSize: '12px', marginBottom: '5px', color: '#d9534f' }}>
                    {error}
                  </li>
                ))}
              </ul>
            </div>
          );
        }

        setShow(true);
        setBasicType("error");
        setBasicTitle(errorMessage);

        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Bulk Uploaded Active SKUs",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      const errorMessage = error.response?.data?.message || "An error occurred";
      setUploadedFileData([]);
      setShow(true);
      setBasicType("error");
      setBasicTitle(errorMessage);

      // User Action Triggering
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Bulk Uploaded Active SKUs",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };


  const onClickUploadSkuMasterData = (event) => {
    setUploadedFileData([])
    setSliderOpen(true);
    setSliderType(2);
    setSliderCl("slider-25");
    setSliderTitle("Upload Active SKU Data");
    setOverlyBlock("show-m");
  };

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }

  const onClickingUpdateSkuData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const isActiveBool = normalizeIsActive(editFormData.is_active);

    const params = {
      sku_code: editFormData.sku_code?.trim(),
      sku_name: editFormData.sku_name?.trim(),
      sku_category: editFormData.sku_category?.trim(),
      destination_store_name: editFormData.destination_store_name?.trim(),
      destination_store_id: editFormData.destination_store_id?.trim(),
      is_active: isActiveBool,
      is_active_string: isActiveBool ? "Active" : "Inactive",
    };

    const isNeedtoUpdate = Object.keys(duplicatedEditData).some(
      (key) => duplicatedEditData[key] !== editFormData[key]
    );

    if (!isNeedtoUpdate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("No Status changes made In Active SKU Data");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    try {
      const response = await redirectURL.post(
        "indentation/updateActiveSkusData",
        params
      );

      if (response.data.status === "success") {
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Data Updated Successfully");

        if (editFormData.is_active === 1) {
          setIsFormLocked(true);
        }

        // const updatedRowData = rowData.map((row) =>
        //   row._id  === editFormData._id ? editFormData : row
        // );

        // setRowData(updatedRowData);

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Edited Destination",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to update Destination data");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Edited Destination",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }

    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to update Destination data");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Edited Destination",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  }
  const handleAddSkuProduct = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const isActiveBool = normalizeIsActive(editFormData.is_active);
      const params = {
        sku_code: editFormData.sku_code?.trim(),
        sku_name: editFormData.sku_name?.trim(),
        sku_category: editFormData.sku_category?.trim(),
        destination_store_name: editFormData.destination_store_name?.trim().split("-")[1],
        destination_store_id: editFormData.destination_store_id?.trim(),
        is_active: true,
        is_active_string: "Active",
      };

      const requiredFields = ['sku_code', 'sku_name', 'sku_category', 'destination_store_id', 'destination_store_name'];
      const missingFields = requiredFields.filter(field => !params[field] || params[field].trim() === "");

      if (missingFields.length > 0) {
        alert(`Please fill in all required fields: ${missingFields.join(", ")}`);
        return;
      }


      const response = await redirectURL.post("indentation/addNewSku", params);
      console.log("API Response:", response.data);

      if (response.data.status === "success") {
        await getSkuMasterData();
        setShow(true);
        setBasicType("success");
        setBasicTitle("New SKU Added Successfully");
        hideOverlySlideBlock();
      } else {
        setShow(true);
        setBasicType("error");
        setBasicTitle(response.data.message || "Failed to add SKU");
      }

    } catch (error) {
      console.error("Error:", error);
      setShow(true);
      setBasicType("error");
      setBasicTitle(error.response?.data?.message || "Network error occurred");
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  }
  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = { destination_store_id: selectedRow.destination_store_id };
    try {
      const response = await redirectURL.post(
        "masters/deleteDestination",
        params
      );

      if (response.data.status === "success") {
        await getSkuMasterData()
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("Destination Delete Successfully");

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Deleted Destination",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to Delete Destination");

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          aaction: "Deleted Destination",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to Delete Destination");

      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Deleted Destination",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  };

  const onClickDeletePopupCancelBtn = () => {

    setOverlayBlock("show-n");
    setShowDeletePopup(false);
  };


  const onGridReady = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;
    setTimeout(() => autoSizeAllColumns(), 100);
  };

  const setfiltersData = async () => {
    setLoadshow("show-m")
    setOverlayBlock("show-m")
    await getSkuMasterData(currentSku?.value, currentDestination?.value);
    setLoadshow("show-n")
    setOverlayBlock("show-n")
  }

  const statusOptions = [{ label: "Active", value: 1 }, { label: "In Active", value: 0 }]

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "10002" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px", zIndex : "10003" }}
            
          >
          </SweetAlert>
        </div>

        <div className="row" style={{ fontSize: "1rem", fontWeight: "bold", fontFamily: "Arial, sans-serif" }}>
          {/* <div className="col-sm-12">
            <h1 style={{ color: "#B9366D", fontSize: "18px", fontWeight: "bold", fontFamily: "sans-serif" }}>Active Skus</h1>
          </div> */}

          <form className="col-sm-12 p-0 mt-2 mb-4">
            <div className="row m-0 align-items-end">
              {/* Left: Select + Apply/Reset */}
              <div className="col-sm-8 row">

                <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                  <label htmlFor="filterDestination" style={{ fontSize: '13px', fontWeight: 400 }}>
                    Select Destination :
                  </label>
                  <Select
                    id="filterDestination"
                    value={currentDestination}
                    // onChange={(opt) => setCurrentDestination(opt)}
                    onChange={(opt) => {
                      setCurrentDestination(opt);
                      setCurrentSku({ label: "ALL", value: "" });
                    }}
                    options={filterDestinationOptions}
                    styles={selectStyles}
                  />
                </div>

                <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                  <label htmlFor="sku" style={{ fontSize: '13px', fontWeight: 400 }}>
                    Select Sku :
                  </label>
                  <Select
                    id="sku"
                    value={currentSku}
                    onChange={(opt) => { setPrevSku(currentSku); setCurrentSku(opt); }}
                    options={skuOptions}
                    styles={selectStyles}
                  />
                </div>

                <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px" }}>
                  <button
                    type="button"
                    onClick={(e) => { e.preventDefault(); setfiltersData(); }}
                    style={{ backgroundColor: "#93385D", color: "#fff", borderRadius: 5, padding: "8px 20px", border: "none", cursor: "pointer" }}
                  >
                    Apply
                  </button>
                  <button
                    type="button"
                    onClick={async (e) => {
                      e.preventDefault();
                      setLoadshow("show-m");
                      setOverlayBlock("show-m");
                      await getSkuMasterData();
                      setCurrentSku({ label: "ALL", value: "" });
                      setCurrentDestination({ label: "ALL", value: "" });
                      setLoadshow("show-n");
                      setOverlayBlock("show-n");
                    }}
                    style={{ backgroundColor: "#fff", color: "#000", borderRadius: 5, padding: "8px 20px", border: "1px solid #d9d9d9", cursor: "pointer" }}
                  >
                    Reset
                  </button>
                </div>
              </div>

              {/* Right: Add/Upload aligned to flex-end */}
              <div className="col-sm-4 d-flex justify-content-end mt-4">
                <button
                  type="button"
                  onClick={onClickAddNewProduct}
                  style={{ ...addButtonStyle, backgroundColor: "#93385D", color: "#fff", border: "2px solid #93385D", marginRight: 15 }}
                >
                  <IoMdAdd style={{ color: "#fff", fontSize: 18 }} />
                  {" Add"}
                </button>
                <button
                  type="button"
                  onClick={onClickUploadSkuMasterData}
                  className="mr-2"
                  style={{ ...addButtonStyle, backgroundColor: "#F4EBEF", color: "#93385D", border: "2px solid #93385D" }}
                >
                  <MdOutlineFileUpload style={{ color: "#93385D", fontSize: 20 }} />
                  &nbsp;Upload
                </button>
              </div>
            </div>
          </form>

          <div className="col-sm-12 p-0 pl-2 mt-6">
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnWithDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={100}
                onGridReady={onGridReady}
                enableRangeSelection={true}
                gridOptions={{
                  suppressHorizontalScroll: false
                }}
              />
            </div>
          </div>
          <div>

          </div>
        </div>
      </div>
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>

        </div>
        {sliderType === 1 && (
          <form style={{ padding: 20 }} onSubmit={(e) => { e.preventDefault(); handleAddSkuProduct(); }}>

            <label className="mt-2">Destination Store *</label>
            <Select
              ref={destSelectRef}
              options={destinationOptions}
              value={
                editFormData.destination_store_id
                  ? destinationOptions.find(opt => opt.value === editFormData.destination_store_id)
                  : null
              }
              onChange={(opt) => {
                if (!opt) return;
                console.log({ opt });

                setEditFormData({
                  ...editFormData,
                  destination_store_id: opt.value,
                  destination_store_name: opt.label,
                  sku_code: "",
                  sku_name: "",
                  sku_category: ""
                });
                fetchAvailableSkus(opt.value);
                skuSelectRef.current?.clearValue?.(); // also clear SKU select if store changes
              }}
              placeholder="Select Destination Store"
              styles={selectStyles}
              isSearchable
              required
            />

            <label className="mt-2">SKU Code *</label>
            <Select
              ref={skuSelectRef}
              options={availableSkus}
              value={
                editFormData.sku_code
                  ? availableSkus.find(opt => opt.value === editFormData.sku_code)
                  : null
              }
              onChange={(opt) => {
                if (!opt) return;
                setEditFormData({
                  ...editFormData,
                  sku_code: opt.value,
                  sku_name: opt.final_data.sku_name || opt.final_data.product_name || "",
                  sku_category: opt.final_data.sku_category || opt.final_data.category || ""
                });
              }}
              placeholder={loadingSkus ? "Loading SKUs..." : "Select SKU Code"}
              styles={selectStyles}
              isSearchable
              isDisabled={!editFormData.destination_store_id || loadingSkus}
              required
            />

            {/* Auto-filled SKU Name */}
            <label className="mt-2">SKU Name *</label>
            <input
              className="form-control"
              value={editFormData.sku_name}
              onChange={e => setEditFormData({ ...editFormData, sku_name: e.target.value })}
              placeholder="Will be auto-filled from SKU selection"
              required
            />

            {/* Auto-filled SKU Category */}
            <label className="mt-2">SKU Category *</label>
            <input
              className="form-control"
              value={editFormData.sku_category}
              onChange={e => setEditFormData({ ...editFormData, sku_category: e.target.value })}
              placeholder="Will be auto-filled from SKU selection"
              required
            />


            {/* Available SKUs count info */}
            {editFormData.destination_store_id && (
              <div style={{ marginTop: 5, padding: 5 }}>

              </div>
            )}

            {/* <label className="mt-2">Status</label>
            <input
              className="form-control"
              value="Active"
              disabled
              style={{ backgroundColor: '#f8f9fa', color: '#495057' }}
            /> */}

            <div style={{ textAlign: "right", marginTop: 10 }}>
              <button
                id="sample-download-button"
                type="submit"
                disabled={loadingSkus}
              >
                {loadingSkus ? "Loading..." : "ADD"}
              </button>
            </div>
          </form>
        )}
        {sliderType === 2 && (
          <div style={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", padding: 5 }}>
            <div style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}>
              <div className="d-flex justify-content-end mb-10p">
                <button
                  id="sample-download-button"
                  onClick={downloadActiveSkusExcelTemplate}
                >
                  {"Download Sample Template"}
                </button>
              </div>
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleActiveSkusFileChange}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                value={file}
                id="bulkUploadFile"
              />
              <p style={{ color: "red", fontSize: "13px", margin: "0px", marginTop: "10px" }}>
                *Accept .csv & .xlsx files only
              </p>
              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  style={{ backgroundColor: "#93385D", color: "#fff", fontSize: "0.8rem" }}
                  onClick={(e) => {
                    setLoadshow("show-m");
                    setOverlayBlock("show-m");
                    onClickingActiveSkusFileSubmit(e);
                  }}
                >
                  {"Submit"}
                </button>
              </div>
            </div>
          </div>
        )}
        {sliderType === 3 && (
          <form style={{ padding: 20 }}
            onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); onClickingUpdateSkuData(); }}>
            <label>SKU Code *</label>
            <input className="form-control" value={editFormData.sku_code}
              onChange={e => setEditFormData({ ...editFormData, sku_code: e.target.value })}
              disabled /* usually immutable */ required />

            <label className="mt-2">SKU Name *</label>
            <input className="form-control" value={editFormData.sku_name}
              onChange={e => setEditFormData({ ...editFormData, sku_name: e.target.value })} disabled required />

            <label className="mt-2">SKU Category *</label>
            <input className="form-control" value={editFormData.sku_category}
              onChange={e => setEditFormData({ ...editFormData, sku_category: e.target.value })} disabled required />

            <label className="mt-2">Destination Store ID *</label>
            <input className="form-control" value={editFormData.destination_store_id}
              onChange={e => setEditFormData({ ...editFormData, destination_store_id: e.target.value })}
              disabled /* usually key */ required />

            <label className="mt-2">Destination Store Name *</label>
            <input className="form-control" value={editFormData.destination_store_name}
              onChange={e => setEditFormData({ ...editFormData, destination_store_name: e.target.value })} disabled required />

            <label className="mt-2">Status *</label>
            <select className="form-control"
              value={editFormData.is_active ? "true" : "false"}
              onChange={e => {
                const v = e.target.value === "true";
                setEditFormData({ ...editFormData, ...withStatusStrings(v) });
              }}>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>

            <div style={{ textAlign: "right", marginTop: 10 }}>
              <button id="sample-download-button" type="submit">Update</button>
            </div>
          </form>

        )}
      </div>
      {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "40%",
            left: "40%",
            zIndex: "1003",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div className="inventory-delete-popup">
            <p
              style={{
                color: "grey",
                fontSize: "19px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {`Are you sure you want to Delete ${selectedRow ? selectedRow.destination_store_id : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-danger"
                onClick={onClickingPopupDeleteBtn}
              >
                Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={onClickDeletePopupCancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
<div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </>
  );
};

const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "5px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily: "sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
};
const selectStyles = {
  control: (base) => ({
    ...base,
    padding: '1px',
    borderRadius: '5px',
    border: '1px solid #d9d9d9',
    fontSize: '14px'
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: 'normal',
    color: '#333',
    fontSize: "14px"
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "14px",
    fontWeight: state.isSelected ? 'normal' : 'normal',
    backgroundColor: state.isSelected ? '#93385D' : 'white',
    color: state.isSelected ? 'white' : '#333',
    '&:hover': {
      backgroundColor: state.isSelected ? '#93385D' : '#f0f0f0'
    }
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999
  })
}

export default ActiveSkus;